<template>
  <div class="page">
    <div class="container d-flex justify-content-center">
      <div class="card py-3 mt-5 shadow-lg rounded-3" style="border-radius:0; border:none">
        <div class="card-body p-1">
          <h4 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700">Set <span
              style="color: #0092f7">Default</span> Store</h4>

          <form @submit.prevent="setStore">
            <div class="row">
              <div class="col">
                <div class="form-floating mb-3">
                  <div class="form-floating">
                    <select class="form-select" v-model="selectedStore"
                            id="storeSelect" aria-label="Store label select example"
                            required>
                      <option v-for="(store,n) in stores" :value="store">{{ store.StoreName }}</option>
                    </select>
                    <label for="storeSelect">Select Store</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center">
              <button :disabled="loading" type="submit" class="btn">
                <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                {{ loadText }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "StoreSetupForm",
  async beforeMount() {
    await this.$store.commit(`setRegisteredStores`)
    if (this.stores.length === 1) {
      this.selectedStore = this.stores[0];
      this.setStore();
    }else if (this.stores.length === 0){
      responses.showInfo(`Please login to the Franchise`)
      return this.$router.push({ name : `login` });
    }
  },
  computed: {
    stores() {
      return this.$store.getters.getRegisteredStores
    },
    loading() {
      return this.$store.getters.getLoadingState;
    },
    loadText() {
      return this.loading ? `Please Wait...` : `Save`;
    },
  },
  data() {
    return {
      selectedStore: undefined,
    }
  },
  methods: {
    setStore() {
      this.$utils.showLoading()
      let defaultStore = this.selectedStore;
      return this.$store.dispatch('setDefaultStore', defaultStore)
          .then(() => this.$router.push({name: 'user-login'}))
          .finally(() => this.$utils.hideLoading())
    }
  }
}
</script>

<style scoped>
.page {
  height: 100% !important;
  background: rgb(64, 67, 74);
  background: -moz-linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  background: -webkit-linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  background: linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#40434a", endColorstr="#ffffff", GradientType=1);
}

.banner {
  height: 30vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  background: #40434A;
  margin-top: -2px !important;
  max-height: 280px;
}

.btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 500px;
}
</style>
